<header class="page-header">
  <h1>Review AI</h1>
  <p>Revisiona i piani estratti dai PDF prima di attivarli</p>
</header>

@if (message()) {
  <p class="flash">{{ message() }}</p>
}

<div class="layout">
  <aside>
    <ul>
      @for (e of items(); track e.id) {
        <li [class.active]="selected()?.id === e.id" (click)="open(e)">
          <strong>{{ e.status }}</strong>
          <span>{{ e.created_at | date: 'short' }}</span>
          <a [routerLink]="['/machines', e.machine_id]" (click)="$event.stopPropagation()">Macchina</a>
        </li>
      } @empty {
        <li class="muted">Nessuna estrazione. Carica un PDF dal dettaglio macchinario.</li>
      }
    </ul>
  </aside>

  <section>
    @if (selected(); as e) {
      <div class="actions">
        @if (e.status === 'ready_for_review') {
          <button type="button" class="primary" (click)="approve()">Approva piani</button>
          <button type="button" class="danger" (click)="reject()">Rifiuta</button>
        }
        <button type="button" (click)="reload()">Aggiorna</button>
      </div>

      @if (e.error_message) {
        <p class="error">{{ e.error_message }}</p>
      }

      <h2>Figure estratte</h2>
      <div class="figures">
        @for (f of e.figures; track f.id) {
          <figure>
            <img [src]="authSrc(f.url)" [alt]="f.caption || f.figure_ref || 'figura'" />
            <figcaption>{{ f.figure_ref }} — {{ f.caption }}</figcaption>
          </figure>
        }
      </div>

      <h2>Piani proposti</h2>
      @for (p of e.draft_plans; track p.id) {
        <article class="plan">
          <h3>{{ p.title }}</h3>
          <p class="meta">ogni {{ p.frequency_value }} {{ p.frequency_unit }} · {{ p.estimated_minutes || '?' }} min</p>
          <p>{{ p.description }}</p>
          <pre>{{ p.instructions }}</pre>
        </article>
      }
    } @else {
      <p class="muted">Seleziona un'estrazione dalla lista.</p>
    }
  </section>
</div>
